import { useHead } from "@unhead/vue";

function normalizeMetaInfo(metaInfo) {
  if (!metaInfo) return {};
  const info = typeof metaInfo === "function" ? metaInfo() : metaInfo;
  const head = {};

  if (info.title) {
    head.title = info.title;
  }

  if (Array.isArray(info.meta)) {
    head.meta = info.meta.map((item, index) => ({
      ...item,
      key: item.key || item.vmid || item.name || item.property || `meta-${index}`
    }));
  }

  if (Array.isArray(info.link)) {
    head.link = info.link;
  }

  if (Array.isArray(info.script)) {
    head.script = info.script;
  }

  return head;
}

export const metaInfoMixin = {
  created() {
    if (!this.$options.metaInfo) return;
    const self = this;
    useHead(() => {
      const raw =
        typeof self.$options.metaInfo === "function"
          ? self.$options.metaInfo.call(self)
          : self.$options.metaInfo;
      return normalizeMetaInfo(raw);
    });
  }
};

export default {
  install(app) {
    app.mixin(metaInfoMixin);
  }
};
